export default "__VITE_ASSET__TQkEhK97__"